import React, { useEffect, useMemo, useState } from 'react';
import { Router } from 'react-router-dom';
import { ConfigProvider, message, notification } from 'antd';
import { I18nextProvider, useTranslation } from 'react-i18next';
import i18n, { Languages } from './locales';
import zhCN from 'antd/es/locale/zh_CN';
import history from 'libs/history';
import user from 'libs/user';
import tenant from 'libs/tenant';
import utils from 'libs/utils';
import configService from 'services/config';
import { GlobalContext, defaultData, GLOBAL } from 'context';
import routes, { getRoutes } from './config/routes';
import { GlobalSettingProvider, Routes } from '@hrtps/ui';
import { WebAudioProvider } from 'libs/bufferAudio';
import './styles/global.scss';
import { parseHashRoute } from 'utils/common';
import useLanguage from 'hooks/useLanguage';

message.config({
  top: 100,
  duration: 2,
  maxCount: 1,
  rtl: true
});

notification.config({
  maxCount: 1
});

function App() {
  const [global, setGlobal] = useState<GLOBAL>(defaultData);
  const { changeLanguage } = useLanguage();
  const { t } = useTranslation();

  // 获取陪练设置
  const getConfig = async () => {
    let res = await configService.query();

    if (res.success && res.data) {
      setGlobal(global => ({
        ...global,
        coachConfig: {
          groupDisplayName: res.data.groupDisplayName || '陪练组',
          unitDisplayName: res.data.unitDisplayName || '陪练组',
          id: res.data.id
        }
      }));
    }
    // 获取小程序2.0 配置
    let res2 = (await configService.query2()) || {};
    if (res2?.success && res2?.data) {
      // await changeLanguage(Languages.CN)
      setGlobal(global => ({
        ...global,
        coachConfig2: {
          identityDisplayName: res2?.data?.identityDisplayName || '项目',
          groupDisplayName: res2?.data?.groupDisplayName || '场景',
          unitDisplayName: res2?.data?.unitDisplayName || '情境',
          practiceDisplayName: res2?.data?.practiceDisplayName || '练习',
          examDisplayName: res2?.data?.examDisplayName || '考试'
        }
      }));
    }
  };
  // 获取logo
  const getlogo = async () => {
    let res = await configService.logoQuery();
    if (res.success && res.data) {
      let data = res.data || {};
      setGlobal(global => ({
        ...global,
        homePageCode: data.homePageCode || defaultData.homePageCode,
        logo: {
          id: data.id || '',
          logo: data.logo || '',
          logoUrl: data.logoUrl || '',
          name: data.name || ''
        }
      }));
    }
  };

  useEffect(() => {
    const routeInfo = parseHashRoute();
    // 这个界面不需要下面的逻辑
    if (routeInfo.path === '/transfer') {
      return;
    }

    // 企业微信点击链接进来，执行getlogo 的时候，拿到旧的租户id，需要重新获取一下id
    const urltenantId = tenant.getTenantId();
    console.log('租户id==', urltenantId);
    getlogo();
    // 第三方登录后，跳转回来的URL中会有token字段
    let tokenInUrl = utils.getQueryByName('token');
    if (tokenInUrl) {
      user.setToken(tokenInUrl);
      try {
        let url = utils.delQueryInUrl('token');
        if (url) {
          window.location.replace(utils.delQueryInUrl('token'));
        }
      } catch (error) {
        console.log(error);
      }
    }
    if (user.getToken()) {
      getConfig();
      return;
    }
    utils.goLogin();
  }, []);

  const showRoutes = useMemo(() => {
    return getRoutes(global?.coachConfig2);
  }, [global]);
  return (
    <I18nextProvider i18n={i18n}>
      <ConfigProvider locale={zhCN}>
        <GlobalContext.Provider value={Object.assign(global, { setGlobal })}>
          <GlobalSettingProvider siderMenuTheme={'light'}>
            <WebAudioProvider>
              <Router history={history}>
                <Routes routes={showRoutes} />
              </Router>
            </WebAudioProvider>
          </GlobalSettingProvider>
        </GlobalContext.Provider>
      </ConfigProvider>
    </I18nextProvider>
  );
}

export default App;
